import { render, staticRenderFns } from "./TabletBlocker.vue?vue&type=template&id=48e89dba&scoped=true&lang=pug&"
import script from "./TabletBlocker.vue?vue&type=script&lang=js&"
export * from "./TabletBlocker.vue?vue&type=script&lang=js&"
import style0 from "./TabletBlocker.vue?vue&type=style&index=0&id=48e89dba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e89dba",
  null
  
)

export default component.exports